import Image from "next/image";
import React, { useState } from "react";
import styles from "./PreEnrollmentResponse.module.css";
import { useRouter } from "next/router";
import ExistingUserLayout from "../ExistingUserLayout/ExistingUserLayout";
import Link from "next/link";
import { trackEventPreEnrolment } from "@/services/mixpanel";

const PreEnrollmentResponse = ({
  backGround,
  header,
  description,
  buttonName,
  title,
  icon,
  homeButton,
  path,
  homePath,
  handleClearLocalStorage,
  isSuccess,
  handleRetryPayment,
  isVineCrm,
  isVineCrmFail,
  userSelectedProgram,
}: any) => {
  const router = useRouter();

  const [isNavigating, setIsNavigating] = useState(false);
  const [isHomeNavigating, setIsHomeNavigating] = useState(false);

  const navigateToPage = async () => {
    setIsNavigating(true);
    try {
      if (isSuccess && path) {
        trackEventPreEnrolment("complete_application_clicked", {
          program_name: userSelectedProgram || "",
        });
        await handleClearLocalStorage();
        window.location.href = path;
      } else if (isVineCrm && path) {
        window.location.href = path;
      } else if (!isSuccess && handleRetryPayment) {
        await handleRetryPayment();
      }
    } catch (error) {
      console.error(error);
      setIsNavigating(false);
      window.location.href = path;
    }
  };

  const navigateToHome = async (homePath: string) => {
    setIsHomeNavigating(true);
    try {
      if (isVineCrm && homePath) {
        trackEventPreEnrolment("go_to_homepage_clicked", {
          program_name: userSelectedProgram || "",
        });
        await router.push(homePath);
      } else {
        await handleClearLocalStorage();
        await router.push(homePath);
      }
    } catch (error) {
      console.error(error);
      setIsHomeNavigating(false);
    }
  };

  return (
    <ExistingUserLayout isVineCrm={isVineCrm}>
      <div
        className={styles.container}
        style={{
          background: backGround,
        }}
      >
        <div className={styles.resContainer}>
          <Image
            src={icon}
            alt="Success_Img"
            title="Success_Img"
            width={60}
            height={60}
          />
          <div className={styles.content}>
            <h4 className={styles.responseHeader}>{title}</h4>
            <h4
              className={
                isVineCrm ? styles.responseHeaderVine : styles.responseHeader
              }
            >
              {header}
            </h4>
            <p className={styles.responseDescription}>{description}</p>
          </div>
          {isVineCrmFail && (
            <div className={styles.fail}>
              <ul>
                <li className="mb-3">
                  📞
                  <span className={styles.strongText}>
                    Talk to your counsellor
                  </span>{" "}
                  to get a new payment link <strong>OR</strong>,
                </li>
                <li>
                  {" "}
                  🔄
                  <Link href={path} className={styles.linkText}>
                    Continue your application
                  </Link>{" "}
                  to try again
                </li>
              </ul>
            </div>
          )}

          <div className={styles.mobileButton}>
            {homeButton && (
              <button
                className={styles.responseButtonBack}
                onClick={() => navigateToHome(homePath)}
                disabled={isHomeNavigating}
              >
                {isHomeNavigating ? <span>Loading...</span> : homeButton}
              </button>
            )}
            <button
              className={styles.responseButton}
              onClick={navigateToPage}
              disabled={isNavigating}
            >
              {isNavigating ? <span>Loading...</span> : buttonName}
            </button>
          </div>
        </div>
      </div>
    </ExistingUserLayout>
  );
};

export default PreEnrollmentResponse;
